import React from "react";
import { FacilityOrderNewFlowStatusBarTemplate } from "themes/application/facility-order-new-flow-us-intake/components";
import { FacilityOrderNewFlowStatusBarViewStore } from 'application/facility-order-new-flow-us-intake/stores';
import { observer } from "mobx-react";
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new FacilityOrderNewFlowStatusBarViewStore(rootStore, componentProps), 'facilityOrderNewFlowStatusBarViewStore')
@observer
class FacilityOrderNewFlowStatusBar extends React.Component {
	render() {
		return <FacilityOrderNewFlowStatusBarTemplate {...this.props} />;
	}
}

export default FacilityOrderNewFlowStatusBar;